var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('page-header',{attrs:{"screen-name":"Cadastrar Novo","link-items":_vm.linkItems}}),_c('Form',{attrs:{"mode":"insert"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }